import styled from "@emotion/styled";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";

const CustomIconButton = styled(IconButton)`
  border-radius: 50%;
`;

type Props = {
  onClick: () => void;
  hide?: boolean;
  iconColor?: string;
  buttonBgColor?: string;
};

export const ExpandSidebarButton = (props: Props) => {
  const { onClick, hide = false, iconColor = "inherit", buttonBgColor } = props;

  return (
    <CustomIconButton
      onClick={onClick}
      sx={{
        opacity: hide ? 0 : 1,
        pointerEvents: hide ? "none" : "auto",
        transition: hide ? "0" : "opacity 400ms",
        transitionDelay: hide ? "0" : "200ms",
        backgroundColor: buttonBgColor ?? "transparent",
        width: "2.25rem",
        height: "2.25rem",
      }}
      id="toggle-chat-sidebar-button"
    >
      <MenuIcon className="expand-icon" sx={{ color: iconColor }} />
    </CustomIconButton>
  );
};

